import { create } from 'zustand';

interface AuthStore {
  idToken: string | null;
  tokenExpiry: number | null;
  setIdToken: (token: string, expiresIn: number) => void;
  getIdToken: () => string | null;
  clearIdToken: () => void;
}

const useAuthStore = create<AuthStore>((set, get) => ({
  idToken: null,
  tokenExpiry: null,

  setIdToken: (token: string, expiresIn: number) => {
    const expiryTime = Date.now() + expiresIn * 1000;
    set({ idToken: token, tokenExpiry: expiryTime });
  },

  getIdToken: () => {
    const { idToken, tokenExpiry } = get();

    if (!idToken) return null;

    if (tokenExpiry && Date.now() >= tokenExpiry) {
      useAuthStore.getState().clearIdToken();
      return null;
    }

    return idToken;
  },

  clearIdToken: () => {
    set({ idToken: null, tokenExpiry: null });
  },
}));

export default useAuthStore;
